var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:[
    _vm.css(),
    ( _obj = {}, _obj[_vm.css('', 'disabled')] = _vm.disabled, _obj[_vm.css('', 'right-content')] = _vm.rightContent, _obj ) ],attrs:{"for":_vm.value}},[_c('input',{class:_vm.css('input'),attrs:{"id":_vm.value,"type":"radio","name":_vm.name,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":_vm.handleChange}}),_c('span',{class:_vm.css('checkmark')}),(_vm.hasContent)?_c('div',{class:_vm.css('content')},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }